// Seconds are written with a double prime: 45 → 45".
export const fmtSeconds = (v) => `${String(v).trim()}"`;

// Result line for a score derived from a raw time, e.g.
// ("Temps PC", 45, 25) → `Temps: 45", PC= 25`.
const SCORE_SUFFIX_RX = /^(.*?)\s+(PC|PR|NS|WP|z)$/;
export const formatTimeLine = (label, raw, value) => {
  const m = SCORE_SUFFIX_RX.exec(label || "");
  return m
    ? `${m[1]}: ${fmtSeconds(raw)}, ${m[2]}= ${value}`
    : `${label}: ${fmtSeconds(raw)}, ${value}`;
};

// Strips a trailing seconds unit from a field label ("Temps \"", legacy "Temps (s)").
export const stripSecondsUnit = (label) => String(label || "").replace(/\s*(\(s\)|\(sec\)|")$/, "");
